'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

GroupUpdateErrorHandlingService=class GroupUpdateErrorHandlingService extends BaseService{
static get $inject(){
return['notificationService'];
}

constructor(notificationService){
super();
this._notificationService=notificationService;
}

handle(socketResponse){
if(socketResponse.status!=='HttpError'){
this._notificationService.displayNotification(
`An unexpected error occurred updating the group, please contact support (response status: ${socketResponse.status}).`,
'error');
return;
}

let statusCode=_.get(socketResponse,'body.httpStatus');
switch(statusCode){
case 404:
this._notificationService.displayNotification('Sorry, the group you attempted to update no longer exists.','warning');
break;

default:
this._notificationService.displayNotification(
`An unexpected error occurred updating the group, please contact support (status code: ${statusCode}).`,
'error');
break;}

}};

module.exports=GroupUpdateErrorHandlingService;
//# sourceMappingURL=groupUpdateErrorHandlingService.js.map
